import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form", "searchField"];
  connect() {
    this.searchFieldTarget.setAttribute("name", "q[name_cont]");
    this.formTarget.setAttribute("action", "/brands/search");
  }

  search(event) {
    event.preventDefault();
    const form = this.formTarget;
    const url = form.action + "?" + $(form).serialize();

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".main-panel .content").innerHTML = html;
      })
      .catch(err => {
        showCardLoadError(this.element, err);
      });
  }
}
